// extracted by mini-css-extract-plugin
module.exports = {"action-tick":"actionTick_action-tick__2GWIU"};